import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.2.1_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc@3.5.24_db0@0.3.4_45dbb81198ef3b65c04728e44fde21d6/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}